module.exports = __webpack_public_path__ + "img/nolan-elasticsearch2.b87d0e47.svg";